import React from 'react'

const SubmitButton = (props) => {
    const question = props.values.question,
        answerA = props.values.answer_a,
        answerB = props.values.answer_b;

    return (
        <button className="c-btn-primary"
                type="submit"
                onClick={() => {
                    if (question === "" || answerA === "" || answerB === "" ) {
                        alert('必須項目が未入力です。')
                    } else {
                        props.post(props.values)
                    }
                }}>投稿</button>
    )
};

export default SubmitButton
